import { render } from "./BaseSearchBar.vue?vue&type=template&id=7ed228a4"
import script from "./BaseSearchBar.vue?vue&type=script&lang=js"
export * from "./BaseSearchBar.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__